import React from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import Layout from '../Layout'

export default function faq(props) {
    return (
        <Layout props={props}>
            <SEO title={`${global?.storeDetails?.name} | Frequently asked questions`} />

            <div className="px-5 py-4 staticPgWrapper">
                {/* <h2>FAQs</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.terms,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
